import React from 'react';
import PropTypes from 'prop-types';
import { intlShape, injectIntl } from 'react-intl';

// Style
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './LocationMap.css';
import {
  Button,
  Grid,
  Row,
  Col,
  Form,
  FormGroup,
  FormControl,
  ControlLabel,
} from 'react-bootstrap';
import cx from 'classnames';
import FontAwesome from 'react-icons/fa';
// Redux
import { connect } from 'react-redux';

// Google Places Map Component
import GoogleMapLoader from 'react-google-maps-loader';
import { withGoogleMap, GoogleMap, Marker, Circle } from 'react-google-maps';

// Constants
import { googleMapAPI } from '../../../config';

// Assets
import mapPinIcon from './map-pin.png';

// Locale
import messages from '../../../locale/messages';

// Redux Actions
import { setStickyBottom } from '../../../actions/Sticky/StrickyActions';
import { getp } from '../../../helpers/getProp';

const refs = {};

const GoogleMapPlace = withGoogleMap(props => (
  <GoogleMap
    defaultZoom={15}
    ref={map => {
      props.handleFitBounds(map);
      refs.map = map;
    }}
    center={props.bounds.getCenter()}
    defaultOptions={{
      backgroundColor: '',
      scrollwheel: false,
      maxZoom: 18,
      minZoom: 5,
      streetViewControl: false,
      zoomControlOptions: {
        position: google.maps.ControlPosition.RIGHT_TOP,
      },
      mapTypeControl: false,
    }}
  >
    {props.markers.map(m => (
      <Circle
        center={m}
        radius={1000}
        options={{
          fillColor: '#00ADEE',
          strokeColor: '#007A87',
        }}
      />
    ))}
    {/* <Marker
      position={props.markers.position}
      draggable={false}
      icon={{
        url: mapPinIcon
      }}
    /> */}
  </GoogleMap>
));

class LocationMap extends React.Component {
  static propTypes = {
    data: PropTypes.object,
    formatMessage: PropTypes.func,
    intl: intlShape.isRequired,
    height: PropTypes.number,
  };

  constructor(props) {
    super(props);
    this.state = {
      center: {},
      markers: null,
      initialLoad: true,
    };
  }

  componentDidMount() {
    const { setStickyBottom, data, googleMaps } = this.props;
    let sticky = document.querySelector('[data-sticky-bottom]'),
      stickyBottom = 1615;
    var bounds = new google.maps.LatLngBounds();

    const positions = data.listingAddresses.map(a => {
      const pos = new google.maps.LatLng(a.lat, a.lng);
      bounds.extend(pos);
      return pos;
    });

    const sw = bounds.getSouthWest();
    const ne = bounds.getNorthEast();
    bounds.extend(new google.maps.LatLng(sw.lat() - 0.014, sw.lng() - 0.014));

    bounds.extend(new google.maps.LatLng(ne.lat() + 0.014, ne.lng() + 0.014));
    this.setState({ markers: positions, bounds });
    stickyBottom = sticky && sticky.getBoundingClientRect().top;
    setStickyBottom(stickyBottom);
  }

  handleFitBounds = map => {
    const { bounds, initialLoad } = this.state;
    if (map != null && bounds != null) {
      //setCenter
      initialLoad ? map.fitBounds(bounds) : true;
      if (initialLoad) {
        this.setState({ initialLoad: false });
      }
    }
  };

  componentDidUpdate() {
    const { setStickyBottom } = this.props;
    let sticky = document.querySelector('[data-sticky-bottom]'),
      stickyBottom = 1615;
    stickyBottom = sticky && sticky.getBoundingClientRect().top;
    setStickyBottom(stickyBottom);
  }

  render() {
    const { center, markers, bounds } = this.state;
    const { data, intl, height } = this.props;

    let displayName = data.user.profile.displayName;
    let city = data.city;
    let country = data.country;

    return (
      <GoogleMapLoader
        params={{
          libraries: 'places',
          region: 'US',
          language: 'en',
          key: googleMapAPI,
        }}
        render={googleMaps =>
          googleMaps && (
            <Row className={cx(s.pageContent)} data-sticky-bottom>
              <Col xs={12} sm={12} md={12} lg={12} className={cx(s.space2)}>
                <div
                  style={{ height: height || 648 }}
                  title={
                    intl.formatMessage(messages.propertyLocated) +
                    intl.formatMessage(messages.neighborhoodInfo)
                  }
                >
                  <GoogleMapPlace
                    containerElement={
                      <div style={{ width: '100%', height: `100%` }} />
                    }
                    mapElement={
                      <div style={{ width: '100%', height: `100%` }} />
                    }
                    center={center}
                    markers={markers}
                    bounds={bounds}
                    handleFitBounds={this.handleFitBounds}
                  />
                </div>
              </Col>
            </Row>
          )
        }
      />
    );
  }
}

//export default withStyles(s)(LocationMap);

const mapState = state => ({});

const mapDispatch = {
  setStickyBottom,
};

export default injectIntl(
  withStyles(s)(
    connect(
      mapState,
      mapDispatch,
    )(LocationMap),
  ),
);



// WEBPACK FOOTER //
// ./src/components/ViewListing/LocationMap/LocationMap.js